import { Flex, Typography } from 'antd';

import { PGStage } from 'screens/season-overview/types';
import DateTime from 'utils/datetime';

interface PlantingGroupStageRendererProps {
  stage: PGStage;
  plantingGroupStartDate: string;
}

const config = {
  onboarding: {
    label: 'In Onboarding',
    color: '#256AF4',
  },
  planting: {
    label: 'In Planting',
    color: '#52C41A',
  },
  collections: {
    label: 'In Collections',
    color: '#FAAD14',
  },
  closed: {
    label: 'Closed',
    color: '#00000040',
  },
};

const getDaysLeftInStage = (plantingGroupStartDate: string) => {
  const startDate = DateTime.endOfDay(plantingGroupStartDate).format();
  const today = DateTime.endOfDay(DateTime.now()).format();

  const dap120 = DateTime.add(startDate, 120, 'day');
  const dap150 = DateTime.add(startDate, 150, 'day');

  // onboarding
  if (DateTime.isBefore(today, startDate)) {
    return DateTime.diff(startDate, today, 'day'); // days left in onboarding stage
  }

  // planting
  if (
    DateTime.isSameOrAfter(today, startDate) &&
    DateTime.isSameOrBefore(today, dap120)
  ) {
    return DateTime.diff(dap120, today, 'day'); // days left in planting stage
  }

  // collections
  if (
    DateTime.isAfter(today, dap120) &&
    DateTime.isSameOrBefore(today, dap150)
  ) {
    return DateTime.diff(dap150, today, 'day'); // days left in collections stage
  }

  // closed
  return null;
};

const PlantingGroupStageRenderer = ({
  stage,
  plantingGroupStartDate,
}: PlantingGroupStageRendererProps) => {
  const daysLeft = getDaysLeftInStage(plantingGroupStartDate) || 0;

  return (
    <>
      <Flex align="center" gap={6} className="planting-group-stage">
        <div className="dot" style={{ background: config?.[stage]?.color }} />
        <span className="text-sm">{config?.[stage]?.label}</span>
      </Flex>
      {daysLeft > 0 && (
        <Typography.Text
          type="secondary"
          className="season-overview__widget-text--helper"
        >
          {daysLeft} days left
        </Typography.Text>
      )}
    </>
  );
};

export default PlantingGroupStageRenderer;
